// extracted by mini-css-extract-plugin
export default {"wrapper":"ChangeMonitoringStatusCell_wrapper__Nx9op","title":"ChangeMonitoringStatusCell_title__LqQ0j"};